
import styled from 'styled-components';
import { Label } from '@riac/design-system';
import { IReactSelectLabel } from 'src/components/Select/Select.i';


export const ReactSelectLabel = styled(Label)<IReactSelectLabel>`
${({ backgroundColor, theme, inverted, noBorder }) => `
  .react-select {
    .react-select__control, .react-select__menu {
      background-color: ${backgroundColor || (inverted ? theme.black[10]: theme.black[90])};
    }
    .react-select__control {
      cursor: pointer;
      border-radius: 0;
      box-shadow: none;
      ${!noBorder && `border: 1px solid ${theme.black[80]};` || ''}
      font-size: 1.8rem;

      &:focus {
        ${!noBorder && `border: 1px solid ${theme.gold[50]};` || ''}
      }
    }
    .react-select__menu {
      background: ${inverted ? theme.black[10] : theme.black[90]};
      color: ${theme.black[30]};
      border-radius: 0;
      margin-top: 0;
      z-index: 5;
      font-size: 1.8rem;
    }
    .react-select__menu-list {
      padding: 0;
    }
    .react-select__option {
      background-color: ${inverted ? theme.black[10]: theme.black[90]};
      color ${inverted ? theme.black[80] : theme.black[30]};
      padding: 10px;
      cursor: pointer;
    }
    .react-select__option--is-focused, .react-select__option:hover {
      background-color: ${inverted ? theme.black[0] : theme.black[80]};
    }
    .react-select__option--is-selected, .react-select__option--is-selected:hover {
      cursor: default;
      background-color: ${theme.gold[50]};
      color: ${theme.black[90]}
    }
    .react-select__value-container {
      padding: 2px 8px;
      white-space: nowrap;
    }
    .react-select__single-value {
      color: ${inverted ? theme.black[90] : theme.black[0]};
    }
    .react-select__input {
      color: ${inverted ? theme.black[90] : theme.black[0]};
      margin-bottom: 0;
      padding: 0;
    }
    .react-select__indicator-separator {
      display: none;
    }
  }
`}
`;
